import { useCallback, useEffect, useMemo, useState } from 'react';
import { PASSWORD_VALIDATION_LENGTH, PASSWORD_VALIDATION_SYMBOLS } from 'src/constants';

export const usePasswordChecklist = (password: string) => {
  const passwordRules = useMemo(
    () => [
      {
        text: 'rulesPassword.onlyLatinLetters',
        regex: PASSWORD_VALIDATION_SYMBOLS,
        done: false
      },
      {
        text: 'rulesPassword.countSymbols',
        regex: PASSWORD_VALIDATION_LENGTH,
        done: false
      }
    ],
    []
  );
  const [passwordChecklist, setPasswordChecklist] = useState(passwordRules);

  const runThroughPasswordChecklist = useCallback(() => {
    const passwordValidationResult = passwordChecklist.map((rule) => {
      return {
        ...rule,
        done: rule.regex.test(password)
      };
    });

    setPasswordChecklist(passwordValidationResult);
  }, [passwordChecklist, password]);

  useEffect(() => {
    runThroughPasswordChecklist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password]);

  return passwordChecklist;
};
